/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Save_Failed_DescInputs */

const en_toast_save_failed_desc = /** @type {(inputs: Toast_Save_Failed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save sessions to database`)
};

const de_toast_save_failed_desc = /** @type {(inputs: Toast_Save_Failed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten konnten nicht in der Datenbank gespeichert werden`)
};

/**
* | output |
* | --- |
* | "Could not save sessions to database" |
*
* @param {Toast_Save_Failed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_save_failed_desc = /** @type {((inputs?: Toast_Save_Failed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Save_Failed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_save_failed_desc(inputs)
	return de_toast_save_failed_desc(inputs)
});